import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
} from "@material-ui/core";
import { EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, update } from "firebase/database";
import React from "react";
import { BeatLoader } from "react-spinners";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  overflow: "scroll",
  p: 4,
};

const Editjob = ({ open, handleClose, job: passJob }) => {
  const [job, setJob] = React.useState(passJob);
  const [jobFor, setJobFor] = React.useState(job?.jobFor);
  const [title, setTitle] = React.useState(job?.title);
  const [location, setLocation] = React.useState(job?.location);
  const [salary, setSalary] = React.useState(job?.salary);
  const [skill, setSkill] = React.useState(job?.skill);
  const [delayTime, setDelayTime] = React.useState(job?.delayTime);
  const [jobPrice, setJobPrice] = React.useState(job?.jobPrice);
  const [description, setDescription] = React.useState(job?.description);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const updateJob = () => {
    if (
      jobFor &&
      title &&
      location &&
      salary &&
      skill &&
      delayTime &&
      jobPrice &&
      description
    ) {
      setLoading(true);
      const uJob = {
        jobFor,
        title,
        location,
        salary,
        skill,
        delayTime,
        jobPrice,
        description,
      };
      const db = getDatabase();

      update(ref(db, `Jobs/${job?.jobId}`), uJob)
        .then((res) => {
          setLoading(false);
          //   setJobFor("");
          //   setDescription("");
          //   setJobPrice("");
          //   setTitle("");
          //   setLocation("");
          //   setSalary("");
          //   setSkill("");
          //   setError("");
        })
        .catch((err) => {
          setLoading(false);

          setError("Job Add Failed.");
        });
    } else {
      setLoading(false);
      setError("Enter All Input Data");
    }
  };

  return (
    <Modal
      style={{
        overflow: "scroll",
        height: "100vh",
        marginTop: "10px",
      }}
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <FormControl fullWidth>
          <Typography variant="h6">Jobs For</Typography>
          <br />
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={jobFor}
            onChange={(e) => setJobFor(e.target.value)}
            label="Jobs For"
          >
            <MenuItem value={1}>Home Page</MenuItem>
            <MenuItem value={2}>For You Page</MenuItem>
            <MenuItem value={3}>New Job Page</MenuItem>
            <MenuItem value={4}>Trending Job Page</MenuItem>
          </Select>

          <br />
          <br />
          <TextField
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            label="Title"
            variant="outlined"
            color="secondary"
            required
            type="text"
          />
          <br />
          <br />
          <TextField
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            label="Location"
            variant="outlined"
            color="secondary"
            required
            type="text"
          />
          <br />
          <br />
          <TextField
            value={salary}
            onChange={(e) => setSalary(parseFloat(e.target.value))}
            label="Salary"
            variant="outlined"
            color="secondary"
            required
            type="number"
          />
          <br />
          <br />
          <TextField
            value={skill}
            onChange={(e) => setSkill(e.target.value)}
            label="Skill"
            variant="outlined"
            color="secondary"
            required
            type="text"
          />
          <br />
          <br />
          <TextField
            value={delayTime}
            onChange={(e) => setDelayTime(parseFloat(e.target.value))}
            label="Delay Time(Min)"
            variant="outlined"
            color="secondary"
            required
            type="number"
          />
          <br />
          <br />
          <TextField
            value={jobPrice}
            onChange={(e) => setJobPrice(parseFloat(e.target.value))}
            label="Job Price"
            variant="outlined"
            color="secondary"
            required
            type="number"
          />
          <br />
          <br />
          <TextareaAutosize
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            label="Job Description"
            variant="outlined"
            color="secondary"
            required
            type="number"
            minRows={4}
            style={{ width: "100%" }}
          />
          <br />
          <br />
          <p style={{ color: "red" }}>{error}</p>
          <br />
          {loading ? (
            <BeatLoader loading={loading} />
          ) : (
            <Button
              disabled={loading}
              onClick={() => updateJob()}
              style={{ marginBottom: "10px" }}
              color="secondary"
              variant="outlined"
              type="submit"
              endIcon={<EditOutlined />}
            >
              Update Job
            </Button>
          )}
        </FormControl>
        <br />
      </Box>
    </Modal>
  );
};

export default Editjob;
